/**
 * Tracking Integration Manager
 * Initializes and manages all analytics and tracking integrations.
 *
 * Standalone version for co-aurora (no build system).
 * Ported from shopper/src/scripts/track.js
 *
 * Depends on (loaded before this file):
 *   - custom-tracking-base.js  (TrackingBase, TrackingIntegrationManager, window.trackingManager)
 *   - custom-attribution.js    (window.AttributionManager)
 *   - custom-tracking-ga4.js   (window.TrackingGA4)
 *   - custom-tracking-meta.js  (window.TrackingMeta)
 *   - custom-tracking-pinterest.js (window.TrackingPinterest)
 *   - custom-tracking-google-ads.js (window.TrackingGoogleAds)
 *   - custom-tracking-tiktok.js (window.TrackingTikTok)
 *   - custom-tracking-klaviyo.js (window.TrackingKlaviyo)
 */
(function() {
  'use strict';

  function getTrackingConfig() {
    var theme = window.theme || {};
    var analytics = theme.analytics || {};
    var settings = theme.settings || {};

    var metaPixelId = analytics.metaPixelId;
    var ga4MeasurementId = analytics.ga4MeasurementId;
    var googleAdsId = analytics.googleAdsConversionId || settings.google_ads_conversion_id;
    var pinterestTagId = analytics.pinterestTagId;
    var tiktokPixelId = analytics.tiktokPixelId;
    var debug = theme.enable_console_logging || false;

    if (debug) {
      console.info('[Tracking Config]', {
        ga4MeasurementId: ga4MeasurementId,
        googleAdsId: googleAdsId,
        metaPixelId: metaPixelId,
        pinterestTagId: pinterestTagId,
        tiktokPixelId: tiktokPixelId
      });
    }

    return {
      googleAnalytics: {
        enabled: !!ga4MeasurementId,
        measurementId: ga4MeasurementId,
        debug: debug
      },
      googleAds: {
        enabled: !!googleAdsId,
        conversionId: googleAdsId,
        debug: debug
      },
      metaPixel: {
        enabled: !!metaPixelId,
        pixelId: metaPixelId,
        enableConversionsAPI: true,
        debug: debug
      },
      pinterest: {
        enabled: !!pinterestTagId,
        tagId: pinterestTagId,
        enableConversionsAPI: true,
        enableEnhancedMatch: true,
        serverSideMode: true,
        lambdaEndpoint: analytics.lambdaEndpoint || '',
        debug: debug
      },
      tiktok: {
        enabled: !!tiktokPixelId,
        pixelId: tiktokPixelId,
        enableEventsAPI: true,
        enableAdvancedMatching: true,
        debug: debug
      },
      klaviyo: {
        enabled: true,
        enrichAdPlatforms: true,
        includeClv: true,
        includeSegments: true,
        includeEngagement: true,
        debug: debug
      }
    };
  }

  function initializeTracking() {
    /* Ensure base classes are available */
    if (!window.TrackingBase || !window.trackingManager) {
      console.warn('[Tracking] Base classes not loaded - aborting initialization');
      return;
    }

    var config = getTrackingConfig();
    var manager = window.trackingManager;

    try {
      /* GA4 */
      if (config.googleAnalytics.enabled && window.TrackingGA4) {
        manager.register('ga4', new window.TrackingGA4(config.googleAnalytics));
      }

      /* Google Ads */
      if (config.googleAds.enabled && window.TrackingGoogleAds) {
        manager.register('googleAds', new window.TrackingGoogleAds(config.googleAds));
      }

      /* Meta Pixel */
      if (config.metaPixel.enabled && window.TrackingMeta) {
        manager.register('meta_pixel', new window.TrackingMeta(config.metaPixel));
      }

      /* Pinterest */
      if (config.pinterest.enabled && window.TrackingPinterest) {
        manager.register('pinterest', new window.TrackingPinterest(config.pinterest));
      }

      /* TikTok */
      if (config.tiktok.enabled && window.TrackingTikTok) {
        manager.register('tiktok', new window.TrackingTikTok(config.tiktok));
      }

      /* Klaviyo enrichment */
      if (config.klaviyo.enabled && window.TrackingKlaviyo) {
        manager.register('klaviyo', new window.TrackingKlaviyo(config.klaviyo));
      }

      /* Track initial page view after integrations are ready */
      setTimeout(function() {
        manager.trackAll('page_view', {
          page_title: document.title,
          page_location: window.location.href,
          page_referrer: document.referrer
        });
      }, 1000);

    } catch (error) {
      console.error('[Tracking] Failed to initialize integrations', error);
    }
  }

  /* Run on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTracking);
  } else {
    initializeTracking();
  }
})();
